export default function Footer() {
  return (
    <footer className="border-t border-[var(--line)] py-9">
      <div className="mx-auto flex max-w-[1080px] flex-wrap items-center justify-between gap-[18px] px-7 font-mono text-[11.5px] tracking-[0.04em] text-[var(--faint)]">
        <span>
          LiquidBrain.ai &copy;{' '}
          <a
            href="https://nexlayer.com/about"
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-[var(--line)] underline-offset-[3px] transition-colors duration-150 hover:text-[var(--ink)] hover:decoration-[var(--ink)]"
          >
            Nexlayer
          </a>{' '}
          2026
        </span>
        <span>Unlimited tokens &middot; unlimited context &middot; patent-pending engine</span>
      </div>
      <div className="mx-auto mt-4 max-w-[1080px] px-7 font-mono text-[10.5px] leading-[1.5] tracking-[0.02em] text-[var(--faint)]">
        * Prices/projects are a combination of increased performance and running the most efficient model for a workload.
      </div>
    </footer>
  )
}
